var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 9.9999C19.6 15.3018 15.302 19.5999 10 19.5999C4.69809 19.5999 0.400024 15.3018 0.400024 9.9999C0.400024 4.69797 4.69809 0.399902 10 0.399902C15.302 0.399902 19.6 4.69797 19.6 9.9999ZM12.4 6.3999C12.4 7.72539 11.3255 8.7999 10 8.7999C8.67454 8.7999 7.60002 7.72539 7.60002 6.3999C7.60002 5.07442 8.67454 3.9999 10 3.9999C11.3255 3.9999 12.4 5.07442 12.4 6.3999ZM9.99994 11.1999C7.57889 11.1999 5.49276 12.6338 4.54451 14.6988C5.86486 16.2303 7.8192 17.1999 10 17.1999C12.1808 17.1999 14.1351 16.2304 15.4554 14.6989C14.5072 12.6339 12.421 11.1999 9.99994 11.1999Z",
    fill: "#6B7280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/adminIcon.9205075e6620f2fd0d5228cf91c430f8.svg";
export { ForwardRef as ReactComponent };